export const translations = {
  es: {
    payment: {
      successTitle: "¡Pago Exitoso!",
      successMessage: "Tu reserva se ha confirmado y recibirás un correo con los detalles.",
      backToHome: "Volver al inicio",
    },
  },
  en: {
    payment: {
      successTitle: "Payment Successful!",
      successMessage: "Your booking has been confirmed, and you’ll receive an email with the details.",
      backToHome: "Back to Home",
    },
  },
};
